<template>
	<div>
		<div class="second_box">
			<a href="#" v-for="(item,index) in tabArr" :key="index" @click="sendValue(index)" :class="tabArrindex == index ? 'active' : ''">{{item.name}}</a>
		</div>
	</div>
</template>

<script>
	// import firstSecondTabbarValue from '../../firstSecondTabbar.js'; //引入兄弟组建公共js
	export default {
		// props: ['gettabArridx'],
		props: ['firstCateSwiperSendIndex'],
		data() {
			return {
				tabArrindex: null,
				firstTabarrIndex: '',
				activeIndexSecond: '',
				tabArr: [
					{
						name: "分类"
					},
					{
						name: "完结"
					},
					{
						name: "排行"
					},
					{
						name: "限免"
					},
					{
						name: "限时一分"
					},
					{
						name: "标签"
					},
					{
						name: "话题"
					}
				],

			}
		},
		created() {
			// // 接收一级导航兄弟组建传值
			// firstSecondTabbarValue.$on('firstTabbarItemValue', (data) => {
			// 	// console.log(data,'firstTabbarItemValue')
			// 	this.firstTabarrIndex = data;
			// 	this.tabArrindex = null;
			// })
			// //字体颜色显示
			// if (this.gettabArridx != '') {
			// 	this.tabArrindex = this.gettabArridx;
			// } else {
			// 	this.tabArrindex = null;
			// }
		},
		watch: {
		  firstCateSwiperSendIndex(value, oldvalue) {
		    // 接收 swiper组件传过来的索引，导航高亮
		    this.tabArrindex = value
		  }
		},
		methods: {
			sendValue(index) { //二级导航
				console.log(index, 'onChange')
				this.activeIndexSecond = index;
				this.tabArrindex = index;
				this.$emit('firSecondCategroy', this.activeIndexSecond)
				// this.$emit('tabArrindex', this.tabArrindex)
			},
		}
	}
</script>

<style lang="less" scoped>
	.second_box {
		height: 70px;
		line-height: 70px;
		// padding: 0 16px;
		background-color: rgba(255,255,255,.5);
		position: fixed;
		top: 160px;
		left: 0;
		z-index: 999;
		a {
			font-size: 32px;
			/*px*/
			display: inline-block;
			width: 77px;
			// width: 95px;
			padding-right: 16px;
			text-align: center;
			color:#9a9a9a;
		}

		a:first-of-type {
			padding-left: 16px;
		}

		// a:nth-child(4) {
		// 	width: 160px;
		// }
		a:nth-child(5) {
			width: 160px;
		}
		.active {
			font-weight:bold;
			color: #ff4081;
		}
	}
</style>
